<div class="auth-modal">
    <p class="description mt-1">
        {{'COMPONENT.AUTH_MODAL.DESCRIPTION' | translate}}
    </p>

    <div class="row">
        <div class="col-12">
            <div class="d-flex gap-2 paragraph-active mt-3">
                <i-tabler
                        name="clipboard-text"
                        class="icon"></i-tabler>
                <span class="label d-inline d-lg-inline">{{'COMPONENT.AUTH_MODAL.NO_ACCOUNT_DESCRIPTION_1' | translate}}</span>
            </div>
            <div class="d-flex gap-2 paragraph-active mt-3">
                <i-tabler
                        name="headset"
                        class="icon"></i-tabler>
                <span class="label d-inline d-lg-inline">{{'COMPONENT.AUTH_MODAL.NO_ACCOUNT_DESCRIPTION_2' | translate}}</span>
            </div>
        </div>
    </div>
    <div class="flex gap-2 mt-3 flex-column flex-sm-row">
        <p-button
                class="d-block button-secondary w-100"
                styleClass="button-basic button-secondary mx-auto w-100"
                [label]="'COMPONENT.AUTH_MODAL.LOG_IN' | translate"
                routerLink="/auth/login"
                type="button"></p-button>
        <p-button
                class="d-block w-100"
                styleClass="button-basic mx-auto w-100"
                [label]="'COMPONENT.AUTH_MODAL.SIGN_UP' | translate"
                routerLink="/auth/registration-start"
                type="button"></p-button>
    </div>
    <div class="d-flex flex-column gap-3 my-3">
        <button (click)="loginWithGoogle()" class="social-button" type="button">
            <img class="image" [src]="'assets/images/authorization/google_logo.png'" alt="" />
            {{ 'COMPONENT.AUTH_MODAL.CONTINUE_WITH_GOOGLE' | translate }}
        </button>
        <button (click)="loginWithFacebook()" class="social-button" type="button">
            <img class="image" [src]="'assets/images/authorization/facebook_logo.png'" alt="" />
            {{ 'COMPONENT.AUTH_MODAL.CONTINUE_WITH_FACEBOOK' | translate }}
        </button>
    </div>
</div>